module.exports = {"411328001":"滨河街道","411328002":"文峰街道","411328003":"东兴街道","411328004":"兴唐街道","411328005":"泗洲街道","411328101":"源潭镇","411328102":"张店镇","411328103":"郭滩镇","411328104":"湖阳镇","411328105":"黑龙镇","411328106":"大河屯镇","411328107":"龙潭镇","411328108":"桐寨铺镇","411328109":"苍台镇","411328110":"上屯镇","411328111":"毕店镇","411328112":"少拜寺镇","411328113":"祁仪镇","411328114":"马振抚镇","411328300":"城郊乡","411328301":"桐河乡","411328306":"昝岗乡","411328309":"古城乡","411328311":"东王集乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411328.json
// module id = 1769
// module chunks = 0